import { Component, ReactNode } from 'react';
import { useNavigate } from 'react-router';
import { AdminApi } from '../admin-api';
import PageLoading from './PageLoading';

export default function MyApp() {
  const _navigate = useNavigate();
  return <MyAppComp navigate={_navigate} />;
}

class MyAppComp extends Component {
  constructor(readonly props: Readonly<{ navigate?: any }>) {
    super(props);

    this.state = {
      isLoading: true,
    };
  }

  state: Readonly<{
    isLoading: boolean;
  }>;

  async componentDidMount(): Promise<void> {
    const _data = await AdminApi.get('/session');

    if (_data) {
      this.props.navigate('/calendar');
    } else {
      this.props.navigate('/login');
    }
  }

  render(): ReactNode {
    return this.state.isLoading ? (
      <PageLoading />
    ) : (
      <div>Redirecionando...</div>
    );
  }
}
